const DeptSelect = () => import('@pages/reg/DeptSelect')
const DoctorSelect = () => import('@pages/reg/DoctorSelect')
const DoctorSchedule = () => import('@pages/reg/DoctorSchedule')
const DoctorSearch = () => import('@pages/reg/DoctorSearch')
const Confirm = () => import('@pages/reg/Confirm')
const OrderPaid = () => import('@pages/reg/OrderPaid')
const Payment = () => import('@pages/reg/Payment')
const EmergencyScan = () => import('@pages/reg/EmergencyScan')
const EMOrderPaid = () => import('@pages/reg/EMOrderPaid')
const Recharge = () => import('@pages/reg/Recharge')
const RegActivity = () => import('@pages/reg/RegActivity')
const RegNuclein = () => import('@pages/reg/RegNuclein')
const ShopConfirm = () => import('@pages/reg/ShopConfirm')

export const reg = [
  {
    path: '/reg/depts/:ThRegisterId?',
    name: 'RegDeptSelect',
    component: DeptSelect,
    meta: {}
  }, {
    path: '/reg/depts/:deptId/doctors/:ThRegisterId?',
    name: 'RegDoctorSelect',
    component: DoctorSelect,
    meta: {}
  }, {
    path: '/reg/doctors/search',
    name: 'RegDoctorSearch',
    component: DoctorSearch,
    meta: {}
  }, {
    path: '/reg/pay/confirm',
    name: 'RegConfirm',
    component: Confirm,
    meta: {}
  }, {
    path: '/reg/order_paid/:apId',
    name: 'RegOrderPaid',
    component: OrderPaid,
    meta: {}
  }, {
    path: '/reg/pay/payment',
    name: 'RegPayment',
    component: Payment,
    meta: {}
  }, {
    path: '/reg/doctors/:doctorId/schedules',
    name: 'RegDoctorSchedule',
    component: DoctorSchedule,
    meta: {}
  }, {
    path: '/reg/pay/emergency',
    name: 'EmergencyScan',
    component: EmergencyScan,
    meta: {}
  }, {
    path: '/reg/em_order_paid/:apId',
    name: 'RegEMOrderPaid',
    component: EMOrderPaid,
    meta: {}
  },
  {
    path: '/reg/pay/recharge/',
    name: 'Recharge',
    component: Recharge,
    meta: {}
  },
  {
    path: '/reg/pay/RegActivity/',
    name: 'RegActivity',
    component: RegActivity,
    meta: {}
  },
  {
    path: '/reg/pay/RegNuclein/',
    name: 'RegNuclein',
    component: RegNuclein,
    meta: {}
  },
  {
    path: '/reg/pay/store',
    name: 'ShopConfirm',
    component: ShopConfirm,
    meta: {}
  }
]



// WEBPACK FOOTER //
// ./src/router/mod/reg.route.js